import { Component, Input, ViewChild } from '@angular/core';
import { NgxGpAutocompleteDirective, NgxGpAutocompleteModule } from '@angular-magic/ngx-gp-autocomplete';

import { Store } from '@ngrx/store';
import { isNil } from 'lodash';

import { DialogService } from 'primeng/dynamicdialog';

import { InputText } from 'primeng/inputtext';
import { map } from 'rxjs';

import { FreyaCommonModule } from '../../../freya-common/freya-common.module';
import { GoogleHelperService } from '../../../services/google-helper.service';


import { jobToolFeature } from '../../job-tool.reducer';
import { JobCreateLocationsActions } from '../jobv2-create-locations-state/jobv2-create-locations-state.actions';
import { jobCreateSelectors } from '../jobv2-create-state/jobv2-create.selectors';
import { Jobv2ManuallyAddLocationComponent } from '../jobv2-manually-add-location/jobv2-manually-add-location.component';

@Component({
	selector: 'app-jobv2-location',
	standalone: true,
	imports: [
		FreyaCommonModule,
		NgxGpAutocompleteModule,
		Jobv2ManuallyAddLocationComponent,
	],
	templateUrl: './jobv2-location.component.html',
	styleUrls: ['./jobv2-location.component.scss']
})
export class JobV2LocationComponent {

	@Input() locationType: string;
	@Input() nameSpace: string;

	@ViewChild('googleAutocomplete') autocompleteRef: NgxGpAutocompleteDirective;
	@ViewChild('addLocation') addLocationManuallyRef: Jobv2ManuallyAddLocationComponent;
	@ViewChild(InputText) locationInputRef: InputText;

	locationTypeToOpenInManual: string;

	billingAddress$ = this.store.select(jobCreateSelectors.selectBillingAddress);

	invalidLocations$ = this.store.select(jobToolFeature.selectInvalidLocations);
	locationInvalid$ = this.invalidLocations$.pipe(
		map((locations) => locations.includes(this.locationType))
	  );

	constructor(
			private store: Store,
			public googleHelper: GoogleHelperService,
			public dialogService: DialogService,
		) { }

	onAddressSelected(
		address: google.maps.places.AutocompletePrediction,
		locationType: string,
	) {
		const location = this.googleHelper.convertGoogleLocationToCreateLocationInput(address);

		this.store.dispatch(JobCreateLocationsActions.locationEntered({
			locationType: locationType,
			location: {
				...location,
				public: false,
			},
			nameSpace: 'customerInput',
		}));
	}

	onUnitNumberEntered(value: string, locationType: string) {
		if (!isNil(value)) {
		  this.store.dispatch(JobCreateLocationsActions.unitNumberEntered({
			locationType,
			unitNumber: value,
			nameSpace: 'customerInput',
		  }));
		}
	}

	openManualLocation(locationType: string) {
			this.locationTypeToOpenInManual = locationType;
			this.addLocationManuallyRef.open();
			this.addLocationManuallyRef.formType = locationType;
	}

	onInput(locationType: string) {
		this.store.dispatch(JobCreateLocationsActions.locationNotSelected({ locationType }))
	}
}